import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";

type DealerMapProps = {
  lat: number;
  lng: number;
};

const StyledDiv = styled.div`
  width: 100%;
  height: 100%;
`;

const Map: React.FC<DealerMapProps> = ({ lat, lng }) => {
  const ref = useRef(null);
  const [map, setMap] = useState<google.maps.Map>();

  useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current, {}));
    }
  }, [ref, map]);

  const defaultProps = {
    center: {
      lat: lat,
      lng: lng,
    },
    zoom: 15,
  };

  const center = defaultProps.center;
  const zoom = defaultProps.zoom;

  useEffect(() => {
    if(!ref || !ref.current){
      return;
    }
    const map = new window.google.maps.Map(ref.current, {
      center,
      zoom,
    });

    const marker = new google.maps.Marker({
      position: center,
      map: map,
    });
  },[ref]);

  return <StyledDiv ref={ref} id="map" />;
};

export default Map;
